<form [formGroup]="paptasForm" *ngIf="paptasForm" (ngSubmit)="onSubmit()" class="myform">
    <!-- <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="5%" fxLayoutAlign="center"> -->
        
        <div class="p-5">

        <div class="flex justify-center items-baseline flex-wrap">
  
            <div class="flex m-2">
                <mat-form-field [hideRequiredMarker]="true">
            <mat-label>k value</mat-label>
            <input matInput formControlName="gammaVal" autocomplete="off">
            <mat-error *ngIf="paptasForm.invalid && paptasForm.touched">
              <span class="myerror">1.0 &lt; k &le; 1.67</span>
            </mat-error>
          </mat-form-field>
      </div>
  
      <div class="flex m-2">
        <mat-form-field [hideRequiredMarker]="true">
            <mat-label>
              pA / p<sub>0</sub>A<sub>t</sub>

                <!-- <img src="assets/math/paptas_b2.svg" alt=""> -->
                <!-- <p class="source_serif"><i>pA / p<sub>t</sub>A<sup>*</sup></i></p> -->
            </mat-label>
            <input matInput formControlName="paptasVal" autocomplete="off">
            <mat-error *ngIf="paptasForm.invalid && paptasForm.touched">
              Must be greater than 0
            </mat-error>
          </mat-form-field>
      </div>

</div>
    </div>
  
    <!-- <div fxLayoutAlign="center center" class="sbmtArea"> -->
    <div class="sbmtArea flex justify-center items-baseline flex-wrap">

      <button mat-raised-button type="submit" [disabled]="paptasForm.invalid">Calculate</button>
    </div>
  
  </form>
  
  <div class="flex justify-center items-baseline flex-wrap" *ngIf="paptasoBool">

  <div fxLayoutAlign="center" *ngIf="paptasoBool">
    <br><br>
    <table>
      <tr>
        <td>
            <img src="assets/math/mach_b.svg" alt="">
        </td>
        <td> {{ isenMach()}} </td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/ppt_b.svg" alt="">
        </td>
        <td>
          {{ isenp_pt() | number:'.1-5'}}
        </td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/ttt_b2.svg" alt="">
        </td>
        <td>
          {{ isenT_Tt() | number:'.1-5' }}
        </td>
      </tr>
  
      <tr>
        <td>
            <img src="assets/math/aas2.svg" alt="">
        </td>
        <td>{{ isenA_As() | number:'.1-5'}}</td>
      </tr>
  
      <tr>
        <td>
            <img src="assets/math/pm_b2.svg" alt="">
        </td>
        <td>{{ isenpm() | number:'.1-5' }}</td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/ma_b.svg" alt="">
        </td>
        <td>{{ isenmach_angle() | number:'.1-5' }}</td>
      </tr>
  
      <tr>
        <td>
            <img src="assets/math/cfopt_b3.svg" alt="">
        </td>
        <td>{{isen_cfopt() | number:'.1-5' }}</td>
      </tr>
  
      <tr>
  
        <td>
            <img src="assets/math/rhorhot_b.svg" alt="">
        </td>
        <td>{{ isen_rhot() | number:'.1-5' }}</td>
  
      </tr>
    </table>
  </div>